import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

type Controller =
  | 'event-details'
  | 'host-details'
  | 'gifting'
  | 'donation'
  | 'poll'
  | 'wtb'
  | 'rsvp'
  | null;
type PreviewState = {
  isEditingDesign: boolean;
  mwOpenController: Controller;
};

const INITIAL_STATE: PreviewState = {
  isEditingDesign: false,
  mwOpenController: null,
};

const previewSlice = createSlice({
  name: 'preview',
  initialState: INITIAL_STATE,
  reducers: {
    setIsEditingDesign: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isEditingDesign: action.payload,
    }),
    setMwOpenController: (state, action: PayloadAction<Controller>) => ({
      ...state,
      mwOpenController: action.payload,
    }),
    resetMwOpenController: (state) => ({
      ...state,
      mwOpenController: null,
    }),
  },
  selectors: {
    selectIsEditingDesign: (state) => state.isEditingDesign,
    selectMwOpenController: (state) => state.mwOpenController,
  },
});

export const {setIsEditingDesign, setMwOpenController, resetMwOpenController} =
  previewSlice.actions;
export const {selectIsEditingDesign, selectMwOpenController} = previewSlice.selectors;
export const previewReducer = previewSlice.reducer;
